import { gql } from 'apollo-angular';

export const RemoveAttachmentDocument = gql(/* GraphQL*/ `mutation removeAttachment($id: Int!) {
  removeAttachment(id: $id)
}
`);
